import { Flex, Avatar, Button, Image, Modal, ModalBody, Text, Box, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, SimpleGrid, Alert, AlertIcon } from "@chakra-ui/react"
import { Trans, useTranslation } from "next-i18next"
import { TbEdit } from "react-icons/tb"
import {IoFootstepsSharp} from "react-icons/io5"

type Props = {
    isOpen: boolean
    onClose: ()=>void
}

export const NoGeolocalisationModal = ({isOpen, onClose}:Props) => {

    const { t } = useTranslation();
    
    return (
        <>
        <Modal isCentered isOpen={isOpen} onClose={onClose} size="xs" >
            <ModalOverlay />
            <ModalContent maxH="80vh" overflow={"hidden"}>
                <ModalHeader px={4} pb={0}>{t("game.activateGeolocalisation")}</ModalHeader>
                <ModalCloseButton />
                <ModalBody px={4} overflow="auto">
                    <Text pb={4}>
                        <Trans
                            components={{ strong: <strong/>}}
                            i18nKey="game.noGeolocalisation"/>
                    </Text>
                    <Image margin="auto" w="150px" src="/images/gspios_step4.png" alt="No geolocalisation" />
                </ModalBody>
                <ModalFooter py={2} px={2}>
                    <Button size="sm" colorScheme="orange" onClick={onClose} pr={4}>{t("game.close")}</Button>                   
                </ModalFooter>
            </ModalContent>
        </Modal>
        </>
    )
}